/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { LatestBidApprovalFragmentDoc } from './LatestBidApprovalFragment'
import { CarrierRelatedOptionDetailsFragmentDoc } from './CarrierRelatedOptionDetailsFragment'
import { ShipmentBouncedCarrierFragmentDoc } from './ShipmentBouncedCarrierFragment'
export type ICarrierOptionDetailsFragment = { __typename?: 'Bid' } & Pick<
  Types.IBid,
  | 'id'
  | 'acceptedAt'
  | 'amount'
  | 'carrierContactName'
  | 'carrierContactPhone'
  | 'carrierContactPhoneExt'
  | 'carrierContactUserId'
  | 'createdAt'
  | 'declineReason'
  | 'rateCoachGrade'
  | 'shipmentId'
  | 'source'
  | 'sourceChannel'
  | 'sourceSegment'
  | 'status'
  | 'updatedAt'
> & {
    acceptedBy?: Types.Maybe<{ __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>>
    carrierApplication?: Types.Maybe<
      { __typename?: 'CarrierApplication' } & Pick<
        Types.ICarrierApplication,
        'id' | 'dotNumber' | 'mcNumber' | 'name' | 'state'
      > & {
          primaryCarrierManager?: Types.Maybe<
            { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'parentUserId' | 'fullName'>
          >
        }
    >
    carrierContactUser?: Types.Maybe<
      { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'parentUserId' | 'fullName' | 'email'>
    >
    counterBid?: Types.Maybe<
      { __typename?: 'Bid' } & Pick<
        Types.IBid,
        | 'id'
        | 'acceptedAt'
        | 'amount'
        | 'carrierContactPhone'
        | 'carrierContactPhoneExt'
        | 'status'
        | 'shipmentId'
      >
    >
    createdBy: { __typename?: 'User' } & Pick<
      Types.IUser,
      'id' | 'parentUserId' | 'fullName' | 'email'
    >
    latestBidApproval?: Types.Maybe<
      { __typename?: 'BidApproval' } & Pick<Types.IBidApproval, 'id' | 'state' | 'updatedAt'> & {
          updatedBy?: Types.Maybe<{ __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>>
        }
    >
    relatedOptions: Array<
      { __typename?: 'Bid' } & Pick<Types.IBid, 'id' | 'amount' | 'createdAt' | 'status'> & {
          carrierApplication?: Types.Maybe<
            { __typename?: 'CarrierApplication' } & Pick<
              Types.ICarrierApplication,
              'id' | 'name' | 'state'
            >
          >
          createdBy: { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>
        }
    >
    shipment: { __typename?: 'Shipment' } & Pick<Types.IShipment, 'id' | 'state'> & {
        firstPickup: { __typename?: 'ShipmentStop' } & Pick<
          Types.IShipmentStop,
          'id' | 'city' | 'stateCode'
        >
        lastDelivery: { __typename?: 'ShipmentStop' } & Pick<
          Types.IShipmentStop,
          'id' | 'city' | 'stateCode'
        >
        bouncedCarrierAssignments: Array<
          { __typename?: 'CarrierAssignment' } & Pick<
            Types.ICarrierAssignment,
            'id' | 'bouncedAt'
          > & {
              bouncedBy?: Types.Maybe<
                { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>
              >
              carrierApplication: { __typename?: 'CarrierApplication' } & Pick<
                Types.ICarrierApplication,
                'id'
              >
            }
        >
        carrierManager?: Types.Maybe<
          { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'parentUserId' | 'fullName'>
        >
      }
  }

export const CarrierOptionDetailsFragmentDoc = gql`
  fragment CarrierOptionDetails on Bid {
    id
    acceptedAt
    acceptedBy {
      id
      fullName
    }
    amount
    carrierApplication {
      id
      dotNumber
      mcNumber
      name
      state
      primaryCarrierManager {
        id
        parentUserId
        fullName
      }
    }
    carrierContactName
    carrierContactPhone
    carrierContactPhoneExt
    carrierContactUserId
    carrierContactUser {
      id
      parentUserId
      fullName
      email
    }
    counterBid {
      id
      acceptedAt
      amount
      carrierContactPhone
      carrierContactPhoneExt
      status
      shipmentId
    }
    createdAt
    createdBy {
      id
      parentUserId
      fullName
      email
    }
    declineReason
    latestBidApproval {
      ...LatestBidApproval
    }
    relatedOptions {
      id
      ...CarrierRelatedOptionDetails
    }
    rateCoachGrade
    shipmentId
    shipment {
      id
      firstPickup {
        id
        city
        stateCode
      }
      lastDelivery {
        id
        city
        stateCode
      }
      state
      bouncedCarrierAssignments {
        ...ShipmentBouncedCarrier
      }
      carrierManager {
        id
        parentUserId
        fullName
      }
    }
    source
    sourceChannel
    sourceSegment
    status
    updatedAt
  }
  ${LatestBidApprovalFragmentDoc}
  ${CarrierRelatedOptionDetailsFragmentDoc}
  ${ShipmentBouncedCarrierFragmentDoc}
`
